export interface RetainedManualCheckoutForm {
  selectedOrganisationId: string;
  selectedUserId: string;
  selectedProductId: string;
  ticketReference: string;
  manualCheckoutAcknowledged: boolean;
  manualCheckoutConfirmText: string;
}

export type RetainedManualCheckoutAction = RetainedManualCheckoutForm & {
  actionId: string;
  actorAdminUserId: string;
};

let retainedManualCheckoutAction: RetainedManualCheckoutAction | null = null;

export const retainManualCheckoutAction = (
  action: RetainedManualCheckoutAction,
): void => {
  retainedManualCheckoutAction = action;
};

export const clearRetainedManualCheckoutForm = (
  actorAdminUserId?: string,
): void => {
  if (
    actorAdminUserId &&
    retainedManualCheckoutAction?.actorAdminUserId !== actorAdminUserId
  ) {
    return;
  }
  retainedManualCheckoutAction = null;
};

export const readRetainedManualCheckoutAction = (
  actorAdminUserId: string,
): RetainedManualCheckoutAction | null => {
  if (
    !retainedManualCheckoutAction ||
    retainedManualCheckoutAction.actorAdminUserId === actorAdminUserId
  ) {
    return retainedManualCheckoutAction;
  }
  retainedManualCheckoutAction = null;
  return null;
};

export const readRetainedManualCheckoutForm = (
  actorAdminUserId: string,
): RetainedManualCheckoutForm | null => {
  const action = readRetainedManualCheckoutAction(actorAdminUserId);
  return action
    ? {
        selectedOrganisationId: action.selectedOrganisationId,
        selectedUserId: action.selectedUserId,
        selectedProductId: action.selectedProductId,
        ticketReference: action.ticketReference,
        manualCheckoutAcknowledged: action.manualCheckoutAcknowledged,
        manualCheckoutConfirmText: action.manualCheckoutConfirmText,
      }
    : null;
};
